import { CreditMemoDetails, SalseOrgDetails } from "@dana/Services/CreditService";
import CreditDetailsState from "@dana/Store/Data/ViewCredit/CreditDetailsState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

const initialState: CreditDetailsState = {
    isLoading: false,
    creditMemoDetails:{} as any,
    salseOrgDetails:{} as any
};

const ViewCreditDetailsStateImmerReducer = createTypedReducerWithImmer(initialState, {
    "CreditMemoDetailsState/Init": (draft: Draft<CreditDetailsState>, action: { isLoading: boolean }) => {
        draft = { ...initialState, isLoading: action.isLoading };
        return draft;
    },
    "CreditMemoDetailsState/IsLoading": (draft: Draft<CreditDetailsState>, action: { isLoading: boolean }) => {
        draft = { ...draft, isLoading: action.isLoading };
        return draft;
    },
    "CreditMemoDetailsState/LoadCreditDetails": (draft: Draft<CreditDetailsState>, action: { creditMemo: CreditMemoDetails , salseOrgDetails:SalseOrgDetails}) => {

        draft = {
            ...draft,
            creditMemoDetails: action.creditMemo,
            salseOrgDetails:action.salseOrgDetails
        };
        return draft;
    },

});

(reducers as any).viewCreditDetailsState = ViewCreditDetailsStateImmerReducer;

type CreditStateReducers = {
    viewCreditDetailsState: typeof ViewCreditDetailsStateImmerReducer;
};

export type CreditDetailsStateActions = Parameters<CreditStateReducers[keyof CreditStateReducers]>[1] | AnyAction;

